/** Routes that must work with zero authentication (no /api/auth/me gate). */
export const PUBLIC_APP_PATHS = [
  '/',
  '/stress-test',
  '/guest-briefing',
  '/register-select',
  '/register-private',
  '/register-org',
  '/register-code',
  '/register-mentee-code',
  '/portal-login',
  '/companion-instructions',
] as const;

export function isPublicAppPath(pathname: string): boolean {
  const path = (pathname || '/').split('?')[0].replace(/\/$/, '') || '/';
  return (PUBLIC_APP_PATHS as readonly string[]).includes(path);
}
